<template>
    <Row type="none" class="bg-white rounded shadow container-fluid py-4 w-full h-screen grid place-items-center">
        <Modal
            :text="modalText"
            id="modal_show"
        />
        <FormTag>
            <Row type="form-row">
                <InputBox
                    model-name="email"
                    title="user.email"
                    type="email"
                    :model-form="modelForm"
                    :errors="errors"
                    :model-state="modelEmailState"
                />
            </Row>

            <Row type="form-row">
                <InputBox
                    model-name="password"
                    title="user.password"
                    type="password"
                    :model-form="modelForm"
                    :errors="errors"
                    :model-state="modelNotEmptyState"
                />
                <div style="width: 100%; font-size: 14px; text-align: end; padding-right: 8px">
                    <router-link :to="$i18nHelper.getUrl('forgot-password')">{{ $t('user.forgotPassword') }}</router-link>
                </div>
            </Row>

            <RowColumn v-if="$i18n.locale === 'uz'">
                Agar akkauntingiz bo'lmasa,
                <router-link :to="$i18nHelper.getUrl('company/add')">ro'yhatdan o'ting</router-link>
            </RowColumn>
            <RowColumn v-else-if="$i18n.locale === 'ru'">
                Если у вас нет аккаунта,
                <router-link :to="$i18nHelper.getUrl('company/add')">пройдите регистрацию</router-link>
            </RowColumn>
            <RowColumn v-else>
                Here you can
                <router-link :to="$i18nHelper.getUrl('company/add')">create account</router-link>
                if you haven't yet
            </RowColumn>
            <MarginTop/>

            <SubmitRow :is-loading="isLoading" :is-disabled="hasErrors" :do-action="login" text="login.title"/>
        </FormTag>
    </Row>
</template>

<script>
import loginMixin from "../mixin/loginMixin";
import FormTag from "../components/html/FormTag";
import Row from "../components/html/Row";
import InputBox from "../components/InputBox";
import validatorMixin from "../mixin/validatorMixin";
import SubmitRow from "../components/SubmitRow";
import RowColumn from "../components/RowColumn";
import MarginTop from "../components/html/MarginTop";
import Modal from "@/components/html/Modal";
import {mapActions} from "vuex";

export default {
    components: {Modal, MarginTop, RowColumn, SubmitRow, InputBox, Row, FormTag,},
    mixins: [loginMixin, validatorMixin],
    data() {
        return {
            errors: {
                email: null,
                password: null,
            },
            modelForm: {
                email: '',
                password: '',
                isManager: false
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'login.title'},
            ],
            isLoading: false,
        }
    },
    methods: {
        ...mapActions(['setBreadcrumbItems'])
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>

</style>
